"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var paths = {
    dingbatz: "https://cdn.izettle.com/fonts/dingbatz_v3111"
};
var icons = {
    dingbatz: {
        font: {
            name: "Dingbatz",
            fallbacks: [],
            fonts: {
                light: {
                    weight: 300,
                    file: paths.dingbatz + "/Dingbatz-Light.woff"
                },
                regular: {
                    weight: 400,
                    file: paths.dingbatz + "/Dingbatz-Regular.woff"
                }
            }
        },
        glyphs: {
            Piechart: { charCode: 0xf04d },
            Shutdown: { charCode: 0xf04f },
            Edit: { charCode: 0xf070 },
            Person: { charCode: 0xf071 },
            People: { charCode: 0xf072 },
            Home: { charCode: 0xf073 },
            Bank: { charCode: 0xf074 },
            Card: { charCode: 0xf075 },
            Coins: { charCode: 0xf079 },
            Email: { charCode: 0xf07a },
            Position: { charCode: 0xf07c },
            Receipt: { charCode: 0xf07d },
            Cog: { charCode: 0xf07e },
            Heart: { charCode: 0xf07f },
            MapPin: { charCode: 0xf080 },
            Settings: { charCode: 0xf081 },
            BulletList: { charCode: 0xf082 },
            Tag: { charCode: 0xf083 },
            ShoppingCart: { charCode: 0xf084 },
            Date: { charCode: 0xf085 },
            Star: { charCode: 0xf088 },
            Trash: { charCode: 0xf08b },
            Chat: { charCode: 0xf08d },
            Notification: { charCode: 0xf08e },
            ShoppingBag: { charCode: 0xf08f },
            Lock: { charCode: 0xf090 },
            Unlocked: { charCode: 0xf091 },
            Delivery: { charCode: 0xf094 },
            Chip: { charCode: 0xf095 },
            Volume: { charCode: 0xf098 },
            Idea: { charCode: 0xf09a },
            IdentityCard: { charCode: 0xf09b },
            Cloud: { charCode: 0xf09c },
            HideKeyboard: { charCode: 0xf0a0 },
            Backspace: { charCode: 0xf0a1 },
            Library: { charCode: 0xf0b0 },
            123: { charCode: 0xf0b3 },
            Barcode: { charCode: 0xf0b4 },
            BarcodeOK: { charCode: 0xf0c0 },
            Search: { charCode: 0xf0b5 },
            ZoomIn: { charCode: 0xf0b6 },
            ZoomOut: { charCode: 0xf0b7 },
            ShareAndroid: { charCode: 0xf0b8 },
            Share: { charCode: 0xf0b9 },
            Letter: { charCode: 0xf0bc },
            LetterRevert: { charCode: 0xf0bd },
            StoreOpen: { charCode: 0xf0be },
            StoreClosed: { charCode: 0xf0bf },
            Menu: { charCode: 0xf000 },
            Tick: { charCode: 0xf001 },
            Cross: { charCode: 0xf002 },
            BarDiagram: { charCode: 0xf003 },
            Plus: { charCode: 0xf004 },
            Minus: { charCode: 0xf005 },
            ReloadDouble: { charCode: 0xf007 },
            Revert: { charCode: 0xf008 },
            Undo: { charCode: 0xf009 },
            VerticalEllipsis: { charCode: 0xf00c },
            ArrowRight: { charCode: 0xf010 },
            ArrowDown: { charCode: 0xf011 },
            ArrowLeft: { charCode: 0xf012 },
            ArrowUp: { charCode: 0xf013 },
            SimpleArrowRight: { charCode: 0xf018 },
            SimpleArrowDown: { charCode: 0xf019 },
            SimpleArrowLeft: { charCode: 0xf01a },
            SimpleArrowUp: { charCode: 0xf01b },
            Download: { charCode: 0xf01c },
            Import: { charCode: 0xf01d },
            Export: { charCode: 0xf01e },
            Percent: { charCode: 0xf04c },
            CardReaderOne: { charCode: 0xf020 },
            CardReaderOneDisconnected: { charCode: 0xf021 },
            AudioReader: { charCode: 0xf023 },
            AudioReaderDisconnected: { charCode: 0xf024 },
            Miura: { charCode: 0xf026 },
            MiuraDisconnected: { charCode: 0xf027 },
            XAC50: { charCode: 0xf028 },
            XAC50Disconnected: { charCode: 0xf029 },
            Phone: { charCode: 0xf02a },
            Tablet: { charCode: 0xf02b },
            Laptop: { charCode: 0xf02c },
            Camera: { charCode: 0xf02d },
            Headphones: { charCode: 0xf02f },
            Microphone: { charCode: 0xf030 },
            CashDrawer: { charCode: 0xf0ba },
            WiFi: { charCode: 0xf089 },
            WiFiDisabled: { charCode: 0xf08a },
            ReceiptPrinter: { charCode: 0xf031 },
            AudioCable: { charCode: 0xf03b },
            Peripherals: { charCode: 0xf03d },
            BatteryEmpty: { charCode: 0xf0e0 },
            BatteryOneBar: { charCode: 0xf0e1 },
            BatteryTwoBars: { charCode: 0xf0e2 },
            BatteryThreeBar: { charCode: 0xf0e3 },
            BatteryCharging: { charCode: 0xf0e5 },
            BatteryCritical: { charCode: 0xf0e6 },
            ButtonOK: { charCode: 0xf05b },
            ButtonCancel: { charCode: 0xf05c },
            CircledTick: { charCode: 0xf041 },
            CircledPlus: { charCode: 0xf042 },
            CircledCross: { charCode: 0xf043 },
            Clock: { charCode: 0xf044 },
            CircledWarning: { charCode: 0xf045 },
            Help: { charCode: 0xf046 },
            Info: { charCode: 0xf047 },
            Compass: { charCode: 0xf048 },
            Happy: { charCode: 0xf049 },
            Sad: { charCode: 0xf04a },
            Dead: { charCode: 0xf04b },
            CircledMinus: { charCode: 0xf056 },
            Denied: { charCode: 0xf00f },
            NumberZero: { charCode: 0x30 },
            NumberOne: { charCode: 0x31 },
            NumberTwo: { charCode: 0x32 },
            NumberThree: { charCode: 0x33 },
            NumberFour: { charCode: 0x34 },
            NumberFive: { charCode: 0x35 },
            NumberSix: { charCode: 0x36 },
            NumberSeven: { charCode: 0x37 },
            NumberEight: { charCode: 0x38 },
            NumberNine: { charCode: 0x39 },
            Play: { charCode: 0xf0a2 },
            Pause: { charCode: 0xf0a3 },
            TemplateCircle: { charCode: 0xf0f0 },
            MenuBold: { charCode: 0xf0f1 },
            GridSmall: { charCode: 0xf0f4 },
            GridMedium: { charCode: 0xf0f5 },
            GridLarge: { charCode: 0xf0f6 },
            Doodle: { charCode: 0xf0f9 },
            CircledCrossFill: { charCode: 0xf0fb },
            CircledTickFill: { charCode: 0xf0fc },
            CircledOutline: { charCode: 0xf0fd },
            IZettle: { charCode: 0xf100 },
            IZettleSmall: { charCode: 0xf100 },
            IZettleNegative: { charCode: 0xf101 },
            IZettleIcon: { charCode: 0xf10c },
            Facebook: { charCode: 0xf110 },
            Twitter: { charCode: 0xf111 },
            GooglePlus: { charCode: 0xf112 },
            Instagram: { charCode: 0xf114 },
            LinkedIn: { charCode: 0xf115 },
            Apple: { charCode: 0xf120 },
            Android: { charCode: 0xf121 },
            BluetoothLogo: { charCode: 0xf123 },
            NFC: { charCode: 0xf124 },
            ApplePay: { charCode: 0xf125 },
            Contactless: { charCode: 0xf126 },
            AndroidPay: { charCode: 0xf127 },
            SamsungPay: { charCode: 0xf128 },
            Swish: { charCode: 0xf12e },
            SkatteverketLogo: { charCode: 0xf12f },
            MasterCard: { charCode: 0xf130 },
            Maestro: { charCode: 0xf131 },
            MasterCardFull: { charCode: 0xf132 },
            Amex: { charCode: 0xf133 },
            Visa: { charCode: 0xf135 },
            Electron: { charCode: 0xf136 },
            VPay: { charCode: 0xf137 },
            CarteBleue: { charCode: 0xf138 },
            Diners: { charCode: 0xf139 },
            JCB: { charCode: 0xf13a },
            Discover: { charCode: 0xf13b },
            EC: { charCode: 0xf13c },
            ELV: { charCode: 0xf13d },
            ChinaUnionPay: { charCode: 0xf13e },
            CarnetLogo: { charCode: 0xf13f },
            ELO: { charCode: 0xf140 },
            Vipps: { charCode: 0xf141 },
            MobilePay: { charCode: 0xf142 },
            OnlinePay: { charCode: 0xf076 },
            MultiplePayments: { charCode: 0xf078 },
            ShowPassword: { charCode: 0xf092 },
            HidePassword: { charCode: 0xf093 },
            Numeric123: { charCode: 0xf0b3 },
            Send: { charCode: 0xf0c1 },
            CameraSwitch: { charCode: 0xf02e },
            PayPal: { charCode: 0xf12d },
            ImagePlaceholder: { charCode: 0xf0c2 },
            Gift: { charCode: 0xf0c3 },
            Reorder: { charCode: 0xf0f8 }
        }
    }
};
exports.default = icons;
